import { render, staticRenderFns } from "./PriceLabel.vue?vue&type=template&id=72444bc8&"
import script from "./PriceLabel.vue?vue&type=script&lang=js&"
export * from "./PriceLabel.vue?vue&type=script&lang=js&"
import style0 from "./PriceLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports